import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { WorklistComponent } from './list/worklist.component';
import {WorkDetailComponent} from "./work-detail/work-status-detail.component";

const routes: Routes = [
  { path: '', component: WorklistComponent },
  { path: 'work/:id', component: WorkDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorklistRoutingModule {}
